// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var React = require("react");
var Common = require("../utils/Common.res.js");
var FileLoader = require("../utils/FileLoader.res.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var MM_wrk_editor = require("../worker/MM_wrk_editor.res.js");
var Expln_React_Row = require("../../rescript-utils/main/react-mui-components/Expln_React_Row.res.js");
var Expln_React_common = require("../../rescript-utils/main/Expln_React_common.res.js");
var JsxPPXReactSupportU = require("rescript/lib/js/jsxPPXReactSupportU.js");
var Select = require("@mui/material/Select").default;
var MenuItem = require("@mui/material/MenuItem").default;
var AutocompleteVirtualized = require("../ui-utils/AutocompleteVirtualized.res.js");
var IconButton = require("@mui/material/IconButton").default;
var InputLabel = require("@mui/material/InputLabel").default;
var FormControl = require("@mui/material/FormControl").default;
var Delete = require("@mui/icons-material/Delete").default;
var Expln_React_TextFileReader = require("../../rescript-utils/main/react-components/Expln_React_TextFileReader.res.js");

function MM_cmp_context_selector_single(props) {
  var onDelete = props.onDelete;
  var renderDeleteButton = props.renderDeleteButton;
  var allLabels = props.allLabels;
  var onLabelChange = props.onLabelChange;
  var label = props.label;
  var onReadInstrChange = props.onReadInstrChange;
  var readInstr = props.readInstr;
  var parseError = props.parseError;
  var onFileChange = props.onFileChange;
  var fileSrc = props.fileSrc;
  var onSrcTypeChange = props.onSrcTypeChange;
  var srcType = props.srcType;
  var onUrlBecomesTrusted = props.onUrlBecomesTrusted;
  var trustedUrls = props.trustedUrls;
  var availableWebSrcs = props.availableWebSrcs;
  var modalRef = props.modalRef;
  var labelSelectorTextFieldRef = React.useRef(null);
  var actFocusLabelSelector = function () {
    var domElem = labelSelectorTextFieldRef.current;
    if (!(domElem == null)) {
      return domElem.focus();
    }
    
  };
  React.useEffect((function () {
          actFocusLabelSelector();
        }), [readInstr]);
  var actAliasSelected = function (alias) {
    var webSrc = availableWebSrcs.find(function (src) {
          return src.alias === alias;
        });
    if (webSrc !== undefined) {
      return FileLoader.loadFileWithProgress(modalRef, !trustedUrls.includes(webSrc.url), onUrlBecomesTrusted, webSrc.url, "Downloading MM file from \"" + alias + "\"", (function (text) {
                    onFileChange({
                          TAG: "Web",
                          _0: webSrc
                        }, text);
                  }), undefined, (function (msg) {
                    return "An error occurred while downloading from \"" + alias + "\":" + (" " + Belt_Option.getWithDefault(msg, "") + ".");
                  }), undefined);
    }
    throw {
          RE_EXN_ID: Common.MmException,
          _1: {
            msg: "Cannot determine a URL for \"" + alias + "\" alias."
          },
          Error: new Error()
        };
  };
  var rndDeleteButton = function () {
    if (renderDeleteButton) {
      return React.createElement(IconButton, {
                  onClick: (function (param) {
                      onDelete();
                    }),
                  children: Caml_option.some(React.createElement(Delete, {}))
                });
    } else {
      return null;
    }
  };
  var rndSourceTypeSelector = function () {
    if (Belt_Option.isNone(fileSrc)) {
      return React.createElement(FormControl, {
                  size: "small",
                  children: Caml_option.some(null)
                }, React.createElement(InputLabel, {
                      id: "src-type-select-label",
                      children: "Source type"
                    }), React.createElement(Select, {
                      sx: {
                        width: 130
                      },
                      labelId: "src-type-select-label",
                      label: "Source type",
                      value: MM_wrk_editor.mmFileSourceTypeToStr(srcType),
                      onChange: Expln_React_common.evt2str(function (str) {
                            onSrcTypeChange(MM_wrk_editor.mmFileSourceTypeFromStr(str));
                          }),
                      children: Caml_option.some(null)
                    }, React.createElement(MenuItem, {
                          value: "Local",
                          children: "Local"
                        }), React.createElement(MenuItem, {
                          value: "Web",
                          children: "Web"
                        })));
    } else {
      return React.createElement("span", undefined, MM_wrk_editor.mmFileSourceTypeToStr(srcType));
    }
  };
  var rndReadInstrTypeSelector = function () {
    return React.createElement(FormControl, {
                size: "small",
                children: Caml_option.some(null)
              }, React.createElement(InputLabel, {
                    id: "scope-type-select-label",
                    children: "Scope"
                  }), React.createElement(Select, {
                    labelId: "scope-type-select-label",
                    label: "Scope",
                    value: MM_wrk_editor.readInstrToStr(readInstr),
                    onChange: Expln_React_common.evt2str(function (str) {
                          onReadInstrChange(MM_wrk_editor.readInstrFromStr(str));
                        }),
                    children: Caml_option.some(null)
                  }, React.createElement(MenuItem, {
                        value: "ReadAll",
                        children: "Read all"
                      }), React.createElement(MenuItem, {
                        value: "StopBefore",
                        children: "Stop before"
                      }), React.createElement(MenuItem, {
                        value: "StopAfter",
                        children: "Stop after"
                      })));
  };
  var rndLabelSelector = function () {
    return React.createElement(AutocompleteVirtualized.make, {
                inputRef: Caml_option.some(labelSelectorTextFieldRef),
                value: label,
                options: allLabels,
                onChange: onLabelChange,
                size: "small",
                label: "Label"
              });
  };
  var getFileNameFromFileSrc = function (fileSrc) {
    if (fileSrc !== undefined && fileSrc.TAG === "Local") {
      return fileSrc.fileName;
    }
    
  };
  var getAliasFromFileSrc = function (fileSrc) {
    if (fileSrc !== undefined && fileSrc.TAG !== "Local") {
      return fileSrc._0.alias;
    }
    
  };
  var rndSourceSelector = function () {
    if (srcType === "Local") {
      var fileName = getFileNameFromFileSrc(fileSrc);
      if (Belt_Option.isNone(fileName)) {
        return React.createElement(Expln_React_TextFileReader.make, {
                    onChange: (function (selected) {
                        if (selected !== undefined) {
                          return onFileChange({
                                      TAG: "Local",
                                      fileName: selected[0]
                                    }, selected[1]);
                        }
                        
                      })
                  });
      } else {
        return React.createElement("span", undefined, Belt_Option.getWithDefault(fileName, "<fileName>"));
      }
    } else {
      var alias = getAliasFromFileSrc(fileSrc);
      if (Belt_Option.isNone(alias)) {
        return React.createElement(FormControl, {
                    size: "small",
                    children: Caml_option.some(null)
                  }, React.createElement(InputLabel, {
                        id: "alias-select-label",
                        children: "Alias"
                      }), React.createElement(Select, {
                        sx: {
                          width: 200
                        },
                        labelId: "alias-select-label",
                        label: "Alias",
                        value: Belt_Option.getWithDefault(alias, ""),
                        onChange: Expln_React_common.evt2str(actAliasSelected),
                        children: Caml_option.some(availableWebSrcs.map(function (webSrc, i) {
                                  return JsxPPXReactSupportU.createElementWithKey(String(i), MenuItem, {
                                              value: webSrc.alias,
                                              children: Caml_option.some(webSrc.alias)
                                            });
                                }))
                      }));
      } else {
        return React.createElement("span", undefined, Belt_Option.getWithDefault(alias, "<web-src-alias>"));
      }
    }
  };
  var rndReadInstr = function () {
    if (parseError !== undefined) {
      return React.createElement("pre", {
                  style: {
                    color: "red"
                  }
                }, "Error: " + parseError);
    }
    if (fileSrc === undefined) {
      return null;
    }
    var tmp;
    switch (readInstr) {
      case "ReadAll" :
          tmp = null;
          break;
      case "StopBefore" :
      case "StopAfter" :
          tmp = rndLabelSelector();
          break;
      
    }
    return React.createElement(Expln_React_Row.make, {
                children: Caml_option.some(null)
              }, rndReadInstrTypeSelector(), tmp);
  };
  return React.createElement(Expln_React_Row.make, {
              alignItems: "center",
              spacing: 1,
              children: Caml_option.some(null)
            }, rndDeleteButton(), rndSourceTypeSelector(), rndSourceSelector(), rndReadInstr());
}

var make = MM_cmp_context_selector_single;

exports.make = make;
/* react Not a pure module */
